// Code review - In Progress
// Documentation - In Progress
import { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import MainPopup from "../popup-containers/MainPopup";
import * as XLSX from "sheetjs-style";
import {
  projectMasterExportHeaders,
  projectMasterHeaders,
} from "../components/HeaderAttribute";
import toast from "react-hot-toast";
import {
  BindAPI,
  BindPostAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import { useLocation } from "react-router-dom";
import ProjectPopup from "../popup-containers/ProjectPopup";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";
import { useUserCapability } from "../components/ConstantReducerProvider";
const ProjectMaster = () => {
  const location = useLocation();
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;

  // All visible functionality useState hooks handling.
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // Services Category Master insert and edit useState hooks handling .
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [bindBranchProject, setBindBranchProject] = useState([]);
  const [branchProject, setBranchProject] = useState("");
  const [branchProjectError, setBranchProjectError] = useState("");
  const [Project, setProject] = useState("");
  const [mstProjectId, setMstProjectId] = useState("");
  const [projectError, setProjectError] = useState("");
  const [popUpDropDownData, setPopUpDropDownData] = useState({});
  // All bind data value useState hooks handling.
  const [bindProjectDatas, setBindProjectDatas] = useState([]);
  const [ProjectData, setProjectData] = useState("");

  // Rowindex, Popup, Pagination, next page and other some useState hooks handling.
  const [rowIndex, setRowIndex] = useState("");
  const [popUpOpen, setpopUpOpen] = useState(false);

  // Language translate useState hooks handling.
  const [languageCodeKey, setLanguageCodekey] = useState([]);
  const [languageGetCode, setLanguageGetCode] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  // This function is helping for Language translation .
  useEffect(() => {
    const getLanguageCode = async () => {
      const response = await BindAPI("LanguageAPI/GetLanguage");
      setLanguageCodekey(response.data.Table);
    };
    getLanguageCode();
  }, []);

  useEffect(() => {
    
    const data = {
      languageCode: "en",
    };
    const BindAllmasterData = async () => {

      const [profile] = userProfileDatas;

      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };

      const bindReferredBydatadrp = await BindPostAPI([data], "LocationAPI/GetLocation");

      const filteredData = bindReferredBydatadrp.data.Table;
      const filteredWithBlockedByNull = filteredData.filter(
        (item) => item.BlockedBy === null,
      );

      bindBranchProjectData(filteredWithBlockedByNull);
    };
    BindAllmasterData();
  }, []);

  const bindBranchProjectData = async (resultdata) => {
    try {
      if (resultdata.length > 0) {
        const branchProjectDD = resultdata.map((m) => ({
          value: m.MstLocationId,
          label: m.LocationName_en,
        }));
        setBindBranchProject(branchProjectDD);
      } else {
        setBindBranchProject([]);
      }
    } catch (error) {
      console.error("Error fetching state data:", error);
    }
  };

  useEffect(() => {
    var languageKeys = languageCodeKey.map((item) => item.LanguageKey);
    setLanguageGetCode(languageKeys);
  }, [languageCodeKey]);

  // This function is helping for Popup open .
  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  // This function is helping for Popup close .
  const handleClose = () => {
    setpopUpOpen(false);
  };

  // This function is helped to the viwe, delete, block and unblock
  // input value via rowindex passing for Services Category .
  const handleServiceCategory = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    const projectData = bindProjectDatas[rowIndex];
    //Location DropDown Value Start
    const locationDropDownValue = bindBranchProject.find(
      (item) => item.value === projectData.MstBranchProjectId,
    );
    const editLocationDropDownValue = {
      value: projectData.MstBranchProjectId,
      label: locationDropDownValue ? locationDropDownValue.label : "Unknown",
    };
    const autoDropDownValues = [editLocationDropDownValue];
    setPopUpDropDownData(autoDropDownValues);
    setProjectData(bindProjectDatas[rowIndex]);
  };

  // This function is helped to edit the input value via rowindex passing and helping
  // to visible handling for Services Category.
  const handleEdit = (rowIndex) => {
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setProject(bindProjectDatas[rowIndex].ProjectName_en);
    setBranchProject(bindProjectDatas[rowIndex].MstBranchProjectId);
    setMstProjectId(bindProjectDatas[rowIndex].MstProjectId);
  };

  // This is Services Category grid page add button visible handling functionality .
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setProject("");
  };

  // This is ovrall cancel button visible handling functionality .
  const cancel = () => {
    setSubmitBtnDisabled(false);
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setProjectError("");
    setProject("");
    setBranchProjectError("");
    setBranchProject("");
    fetchProjectData();
    setIsLoading(false);
  };

  // This function is helped to the edit, viwe, delete, block and unblock flag passing and hanling the API
  // response for those all and passing the rowindex for Services Category.
  const createdBy = sessionStorage.getItem("createdBy");
  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    if (flag == 1 || flag == 2) {
      // validation start
      let projectValidate = "";
      projectValidate = Project.length > 0 ? "" : "Enter Project";
      setProjectError(projectValidate);

      let branchProjectValidate = "";
      branchProjectValidate = branchProject ? "" : "Enter Branch/Project Name";
      setBranchProjectError(branchProjectValidate);

      // Validation end

      if (projectValidate || branchProjectValidate) {
        setIsOpen(true);
      }

      if (!projectValidate && !branchProjectValidate) {
        setIsOpen(false);
        const languageKeys = [
          "ta", // Tamil
          "hi", // Hindi
          "mr", // Marathi
          "gu", // Gujarati
          "kn", // Kannada
          "ml", // Malayalam
          "te", // Telugu
          "bn", // Bengali
          "or", // Oriya
        ];
        const translatedTexts = [];
        for (let i of languageKeys) {
          const translateText = await LanguageTranslatorAPI(Project, i);
          translatedTexts.push(
            translateText.data.data.translations[0].translatedText,
          );
        }
        const projectPayload = {
          mstProjectId: mstProjectId ? mstProjectId : 0,
          mstBranchProjectId: branchProject,
          projectEn: Project,
          projectTa: translatedTexts[0],
          projectHi: translatedTexts[1],
          projectMr: translatedTexts[2],
          projectGu: translatedTexts[3],
          projectMl: translatedTexts[4],
          projectTe: translatedTexts[5],
          projectKn: translatedTexts[6],
          projectBn: translatedTexts[7],
          projectOr: translatedTexts[8],
          createdBy: parseInt(createdBy),
          flag: flag,
        };
        const response = await IUDAPI(projectPayload, "ProjectAPI/IUDProject");
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Project added successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add Project data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Project updated successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update Project data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
      }
    } else {
      const projectPayload = {
        mstProjectId: bindProjectDatas[items].MstProjectId,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI(projectPayload, "ProjectAPI/IUDProject");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Project data deleted successfully 🗑️", 1000, cancel());
          cancel();
        }
        else if (response.data.Table[0].Result === "P") {
          toast.error("Project cannot be deleted because it is being used.👎", {
            duration: 1000,
            position: "top-center",
          });

          setTimeout(cancel, 2000);
        }

        else {
          toast.error("Failed to delete Project data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("Project data blocked successfully 🚫", 1000, cancel());
          cancel();
        } else {
          toast.error("Failed to block Project data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success(
            "Project data unblocked successfully ✅",
            1000,
            cancel(),
          );
          cancel();
        } else {
          toast.error("Failed to unblock Project data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
    }
  };

  // This hook function is helped to bind all data from Services Category master table.
  useEffect(() => {
    fetchProjectData();
  }, []);

  const fetchProjectData = async () => {
    setIsLoading(true);
    if (userProfileDatas && userProfileDatas[0]) {
      const data = {
        mstOrganizationStructureId: userProfileDatas[0]?.MstOrganizationId,
        mstBranchId: userProfileDatas[0]?.MstLocationId,
        mstSdpId: userProfileDatas[0].MstSDPId
          ? userProfileDatas[0].MstSDPId
          : 0,
        mstUserId: userProfileDatas[0]?.MstUserId,
        mstRoleId: userProfileDatas[0]?.MstRoleId,
      };
      const response = await BindPostAPI(data, "ProjectAPI/BindProjectGrid");

      setBindProjectDatas(response.data.Table);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (location.pathname == "/project") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
      fetchProjectData();
    }
  }, [location]);

  const handleExport = async () => {
    try {
      if (userProfileDatas && userProfileDatas[0]) {
        const data = {
          mstOrganizationStructureId: userProfileDatas[0]?.MstOrganizationId,
          mstBranchId: userProfileDatas[0]?.MstLocationId,
          mstSdpId: userProfileDatas[0].MstSDPId
            ? userProfileDatas[0].MstSDPId
            : 0,
          mstUserId: userProfileDatas[0]?.MstUserId,
          mstRoleId: userProfileDatas[0]?.MstRoleId,
        };
        const response = await BindPostAPI(
          data,
          "ProjectAPI/BindProjectExport",
        );
        const rows = response?.data?.Table || [];
        if (rows.length === 0) {
          await IUDAPI(
            {
              mstUserId: parseInt(createdBy, 10),
              sp: "PROJECT MASTER",
              action: "EXCEL EXPORT",
              status: "FAILED",
              tableName: "mst_project",
              description: "No data available to export",
            },
            "Log/IUDLog",
          );
          toast.error("No data available to export", {
            duration: 1000,
            position: "top-center",
          });
          return;
        } else {
          await IUDAPI(
            {
              mstUserId: parseInt(createdBy, 10),
              sp: "PROJECT MASTER",
              action: "EXCEL EXPORT",
              status: "SUCCESS",
              tableName: "mst_project",
              description: `Project Master Excel exported successfully. Total Records: ${rows.length}`,
            },
            "Log/IUDLog",
          );
        }
        exportData(
          projectMasterExportHeaders.map((col) => col.title),
          rows,
        );
      }
    } catch (error) {
      console.error("Export error", error);
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "PROJECT MASTER",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "mst_project",
          description: error?.message || "Excel export failed",
        },
        "Log/IUDLog",
      );
      toast.error("Failed to export Excel 👎", {
        duration: 1000,
        position: "top-center",
      });
    }
  };

  const exportData = (columns, rows) => {
    /* ---------- TITLE ---------- */
    const titleRow = [
      {
        v: "Project Master",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    const spacingRow = [{ v: "" }];

    /* ---------- HEADER ---------- */
    const headerRow = columns.map((col) => ({
      v: col,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left", wrapText: true },
      },
    }));

    /* ---------- DATA ROWS ---------- */
    const dataRows = rows.map((row, index) => {
      const baseStyle =
        index % 2 === 1 ? { fill: { fgColor: { rgb: "F2F2F2" } } } : {};

      return [
        { v: index + 1, s: baseStyle }, // S.No
        { v: row.MstProjectId, s: baseStyle },
        { v: row.LocationName_en, s: baseStyle },
        { v: row.ProjectName_en, s: baseStyle },
        { v: row.ProjectName_ta, s: baseStyle },
        { v: row.ProjectName_hi, s: baseStyle },
        { v: row.ProjectName_mr, s: baseStyle },
        { v: row.ProjectName_gu, s: baseStyle },

        { v: row.ProjectName_kn, s: baseStyle },
        { v: row.ProjectName_ml, s: baseStyle },

        { v: row.ProjectName_te, s: baseStyle },
        { v: row.ProjectName_bn, s: baseStyle },
        { v: row.ProjectName_or, s: baseStyle },
        { v: row.FullName_en, s: baseStyle },
      ];
    });

    /* ---------- SHEET DATA ---------- */
    const wsData = [titleRow, spacingRow, headerRow, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ---------- DYNAMIC COLUMN WIDTHS (CORRECT) ---------- */
    ws["!cols"] = columns.map((header, colIndex) => {
      // start with header text length
      let maxLength = header?.length || 10;

      // check each exported row
      dataRows.forEach((rowArray) => {
        const cell = rowArray[colIndex]?.v;

        if (cell !== null && cell !== undefined) {
          maxLength = Math.max(maxLength, cell.toString().length);
        }
      });

      return {
        width: Math.min(Math.max(maxLength + 2, 10), 40),
      };
    });

    /* ---------- ROW HEIGHTS ---------- */
    ws["!rows"] = [
      { hpt: 30 }, // Title
      { hpt: 15 }, // Space
      { hpt: 22 }, // Header
      ...Array(rows.length).fill({ hpt: 18 }),
    ];

    /* ---------- BORDERS ---------- */
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellRef]) continue;

        ws[cellRef].s = {
          ...ws[cellRef].s,
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    }

    /* ---------- WORKBOOK ---------- */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Project Master");

    XLSX.writeFile(wb, "Project_Master.xlsx");
  };

  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Project Master"
          header={projectMasterHeaders}
          records={bindProjectDatas}
          handleEdit={handleEdit}
          handleAction={handleServiceCategory}
          showAdd={showAdd}
          handleExportBtn={true}
          handleExport={handleExport}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div class="w-full ">
          <AddScreenTitle
            addScreenTitle={addScreenTitle}
            updateScreenTitle={updateScreenTitle}
            title="Project Master"
          />
          <div class={mainTable.firstMainAddScreen}>
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <div>
                      <AutoDropDown
                        classStar="text-red-500"
                        title={"Branch/Project"}
                        options={bindBranchProject}
                        placeholder={"Select"}
                        name={"location"}
                        selectedOption={
                          location
                            ? bindBranchProject.find(
                              (x) => x.value == branchProject,
                            )
                            : ""
                        }
                        controlFunc={(value) => {
                          setBranchProject(value.value);
                          setBranchProjectError(
                            value ? "" : "Select Branch/Project Name",
                          );
                        }}
                        controlFuncBlur={() => {
                          setBranchProjectError(
                            branchProject ? "" : "Select Branch/Project Name",
                          );
                        }}
                        Class="custom-class"
                        tabIndex='0'
                      />
                      {branchProjectError && (
                        <span class="text-red-500">{branchProjectError}</span>
                      )}
                    </div>
                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      title={"Project"}
                      name={"Project"}
                      maxLength={100}
                      tabIndex='0'
                      content={Project}
                      controlFunc={(e) => {
                        const value = e.target.value;
                        setProject(value);
                        setProjectError(
                          value.length > 0
                            ? /^[\S]+(?:\s[\S]+)*$/.test(value)
                              ? "" // No error if the input is valid
                              : ""
                            : "Enter project", // Error message if the input is empty
                        );
                      }}
                      controlFuncBlur={(e) => {
                        const trimmedValue = e.target.value.trim();
                        setProject(trimmedValue);
                        setProjectError(
                          trimmedValue.length > 0
                            ? /^[\S]+(?:\s[\S]+)*$/.test(trimmedValue)
                              ? "" // No error if the input is valid
                              : "Only single spaces between words allowed"
                            : "Enter project", // Error message if the input is empty
                        );
                      }}
                    />
                    {projectError && (
                      <span class="text-red-500">{projectError}</span>
                    )}
                    <Buttons
                      addScreenTitle={addScreenTitle}
                      updateScreenTitle={updateScreenTitle}
                      handleSubmit={handleSubmit}
                      cancel={cancel}
                      disabledBtn={submitBtnDisabled ? true : false}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleServiceCategory}
      >
        <div className=" flex flex-col gap-3">
          <PopUpScreenTitle
            title="Project Master"
            setpopUpOpen={handleClose}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <ProjectPopup data={ProjectData} data1={popUpDropDownData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default ProjectMaster;
